async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(data.message || `Request failed (${response.status})`);
    err.reasons = data.reasons;
    throw err;
  }
  return data;
}

export async function fetchVehicleLifecycleEvents(filters = {}) {
  const params = new URLSearchParams();
  if (filters.eventType) params.set("event_type", filters.eventType);
  if (filters.vehicleSourceId) params.set("vehicle_source_id", filters.vehicleSourceId);
  if (filters.previousStatus) params.set("previous_status", filters.previousStatus);
  if (filters.newStatus) params.set("new_status", filters.newStatus);
  if (filters.sellerType) params.set("seller_type", filters.sellerType);
  if (filters.city) params.set("city", filters.city);
  if (filters.eventFrom) params.set("event_from", filters.eventFrom);
  if (filters.eventTo) params.set("event_to", filters.eventTo);
  if (filters.limit) params.set("limit", String(filters.limit));
  const query = params.toString();
  const data = await requestJson(
    `/api/admin/mobility/vehicle-lifecycle-events${query ? `?${query}` : ""}`
  );
  return data.events || [];
}

export async function patchVehicleListingLifecycleStatus(listingId, payload) {
  return requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(listingId)}/lifecycle-status`,
    {
      method: "PATCH",
      body: JSON.stringify(payload),
    }
  );
}
